<template>
    <modal
        :title="title"
        :id="id"
        :actionButtons="false"
        size="full"
        :closeButton="true"
        @shown="shown"
        @hidden="hidden"
    >
        <div v-if="loaded">
            <div class="container d-none">
                <receipt id="receiptContent" :billing="billing" :customer="customer" :invoice="invoice"
                         :company="company"/>
            </div>
            <div id="printContent" class="container">
                <div class="row justify-content-center">
                    <div class="col-12 px-5">
                        <company-print-header></company-print-header>
                        <hr/>
                        <!-- / .row -->
                        <table class="table table-borderless mb-0">
                            <tbody>
                            <tr>
                                <td class="text-muted">
                                    <div v-if="invoice.invoiceNumber && !preview">
                                        <span>{{ $t('Invoice #') }}{{ invoice.invoiceNumber }} /</span>
                                        {{ invoice.createdAt | moment('DD MMMM, YYYY') }}
                                    </div>
                                </td>
                                <td style="text-align: right;">
                                    <h6 class="text-uppercase text-muted">
                                        <span v-if="preview">{{ $t('invoice.preview-to') }}</span>
                                        <span v-else>{{ $t('Invoiced to') }}</span>
                                    </h6>

                                    <div class="text-muted" v-if="customer">
                                        <strong class="text-body">{{ customer.first_name }} {{
                                                customer.last_name
                                            }}</strong>
                                        <div>{{ customer.phone }}</div>
                                        <div>{{ customer.email }}</div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- / .row -->
                        <div class="row">
                            <div class="col-12">
                                <invoice-table :invoice="invoice"></invoice-table>
                            </div>
                        </div>
                        <div class="row never-page-break">
                            <div class="col-6 d-block ml-auto never-page-break" v-if="!preview">
                                <table class="table table-sm table-borderless my-4">
                                    <thead>
                                    <tr>
                                        <th colspan="2">
                                            {{ $t('Paid amount') }}:
                                        </th>
                                    </tr>
                                    </thead>
                                    <tr v-for="method in invoice.payments" :key="method.paymentMethod">
                                        <td width="70%">{{ $t(method.paymentMethod) }}</td>
                                        <th>
                                            <money :value="method.toPay"></money>
                                        </th>
                                    </tr>
                                    <tr v-if="invoice.payments.length === 0">
                                        <td width="70%">{{ $t('Paid amount') }}:</td>
                                        <th>
                                            <money :value="invoice.totalPaid"></money>
                                        </th>
                                    </tr>
                                    <tr v-if="invoice.totalPrice - invoice.totalPaid > 0">
                                        <td width="70%">{{ $t('Debt') }}</td>
                                        <th>
                                            <money :value="Math.abs(invoice.totalPaid - invoice.totalPrice)"/>
                                        </th>
                                    </tr>
                                    <thead>
                                    <tr v-if="customer.balance < 0 && customer.balance !== (invoice.totalPaid - Math.abs(invoice.totalPrice))">
                                        <th width="70%"><strong>{{ $t('Total debt') }}</strong></th>
                                        <th>
                                            <money style="font-size: 13px;" :value="customer.balance"/>
                                        </th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                        <div class="row">
                            <div v-if="billing.notes" class="col-12">
                                <hr class="my-5"/>
                                <p class="text-muted mb-0">{{ billing.notes }}</p>
                            </div>
                        </div>
                        <!-- / .row -->
                    </div>
                </div>
            </div>
        </div>

        <template slot="modal-header">&nbsp;</template>
        <template slot="modal-footer">
            <div class="card-footer invoiceFooter" style="display:block">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-auto">
                        <button v-if="!preview" type="button" class="btn btn-white mr-2"
                                @click="print('receiptContent')">
                            <i class="fe fe-printer"></i>
                            {{ $t('Print receipt') }}
                        </button>
                        <button type="button" class="btn btn-white mr-2" @click="print()">
                            <i class="fe fe-printer"></i>
                            {{ $t('Print') }}
                        </button>
                        <button type="button" @click="close" class="btn btn-white">{{ $t('Close') }}</button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>


import duration from '@/filters/duration.js';
import Money from "@/components/Money.vue";
import Modal from "@/components/Modal.vue";

import {modalMixins} from '@/mixins/modal.js'
import {mapActions, mapGetters, mapState} from 'vuex';
import CustomSwitch from "@/components/CustomSwitch";
import Receipt from "@/Pages/Sales/Receipt";
import InvoiceTable from "@/components/Invoice/InvoiceTable";
import {PaymentItem} from "@/model-types/invoice";
import CompanyPrintHeader from "@/components/Company/CompanyPrintHeader.vue";

export default {
    name: 'invoice-modal',
    props: {
        id: {type: String, required: true}
    },
    mixins: [modalMixins],
    filters: {duration},
    components: {
        InvoiceTable,
        Receipt,
        CustomSwitch,
        Money,
        Modal,
        CompanyPrintHeader,
    },
    data() {
        return {
            loaded: false,
            billing: {},
            avatar: {},
            hideForm: false,
            title: 'Invoice',
            invoiceId: null,
            preview: false,
            invoice: {}
        }
    },
    created() {

    },

    computed: {
        ...mapState('my-team', {isTeamLoading: 'isFindPending'}),
        ...mapGetters('my-team', {findTeamInStore: 'find'}),
        ...mapGetters('customers', {getCustomer: 'get'}),
        ...mapGetters('invoices', {getInvoice: 'get'}),
        ...mapGetters('my-company', {
            getMyCompany: 'get'
        }),
        company() {
            return this.getMyCompany('mine');
        },

        status() {
            return status(this.invoice.status);
        },

        customer() {
            return this.getCustomer(this.invoice.customerId);
        }
    },
    methods: {
        ...mapActions('invoices', ['get']),
        ...mapActions('customers', {fetchCustomer: 'get'}),

        productPrice(item, quantity) {
            let perServing = item.perServing || 1
            let price = (item.price || {}).retailPrice || 0
            quantity = quantity || perServing
            return price * quantity * perServing
        },

        hidden() {
            var $printSection = document.getElementById("printSection");
            if ($printSection) {
                $printSection.remove();
            }
        },
        print(id = 'printContent') {
            var domClone = document.getElementById(id).cloneNode(true);

            var $printSection = document.getElementById("printSection");
            if (!$printSection) {
                var $printSection = document.createElement("div");
                $printSection.id = "printSection";
                document.body.appendChild($printSection);
            }

            $printSection.innerHTML = "";
            $printSection.appendChild(domClone);
            window.print();
        },
        shown() {
            this.billing = this.company.billing;
            this.billing.avatar = this.company.avatar;

            const {Invoice} = this.$FeathersVuex;
            let data = Invoice.getFromStore('temp');
            if (!data)
                return

            const {invoiceId, previewData, preview} = data
            this.invoiceId = invoiceId;
            delete data._id;
            let promise;

            if (preview) {
                this.preview = true
                this.loaded = true;
                this.invoice = previewData
                promise = Promise.resolve(previewData.customerId)
            } else {
                promise = this.get(this.invoiceId).then(item => {
                    this.loaded = true;
                    this.invoice = item
                    return item.customerId
                });
            }

            promise.then(customerId => {
                this.fetchCustomer(customerId).then(() => {
                    if (data.print)
                        this.print();
                });
            })

            new Invoice({
                model: {},
                _id: 'temp'
            });
        },

        close() {
            this.$root.$emit('bv::hide::modal', this.id);
        },
        getTotalPaid(payments) {
            return payments.reduce((total, item) => total + item.toPay, 0)
        }
    },

}
</script>

<style lang="scss">

@media screen {
    #printContent {
        height: calc(var(--calculated-vh, 1vh) * 100 - 150px);
        color: #000 !important;
        max-width: 100%;
    }
}
.word-break {
    word-break: keep-all;
    white-space: pre-line
}

</style>
